export default __webpack_public_path__ + "static/media/orders.2fe5fc1a.svg";